import { a as patchEsm, b as bootstrapLazy } from './index-24fc0bef.js';

const defineCustomElements = (win, options) => patchEsm().then(() => {
  return bootstrapLazy([["ion-phaser",[[0,"ion-phaser",{"game":[1040],"initialize":[4],"getInstance":[64],"destroy":[64]}]]]], options);
});

export { defineCustomElements };
